


















































































































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import {
    IGetRgAvailableItemListResponse,
    searchUser,
    getRgAvailableItemList,
    getSupportLLMList,
    IChatFormData,
    IOrganization,
    IRGItem,
    ILLMHumanServiceTransferConf,
    saveRobotInfo,
    ChatFormType,
    RoutingAddrType
} from '@/api/rg';
import { orgDetailByPath } from '@/api/cti';
import { cloneDeep } from 'lodash';
import { createTypeMapping } from './util';

@Component
export default class ChatForm extends Vue {
    @Prop({ type: Array, required: true }) readonly robotConfigs!: IChatFormData[];
    @Prop({ type: String, required: true }) readonly userType!: string;
    @Prop({ type: String, required: true }) readonly createType!: string;

    defaultLLMHumanServiceTransferConf: ILLMHumanServiceTransferConf = {
        type: 'FRIDAY',
        routingAddr: '',
        routingAddrType: 'TT_ITEM_ID',
        goToCreateTTPageAfterTransfer: false,
        notShownTiming: {
            whenFirstRoundDialogue: false,
            whenSpecialChars: false
        }
    };

    defaultFormData: IChatFormData = {
        robotName: '',
        llmTenantId: '',
        llmRobotId: '',
        llmModel: '',
        prompt: '',
        authorizedOrgList: [],
        authorizedUserList: [],
        llmHumanServiceTransferConf: this.defaultLLMHumanServiceTransferConf,
        isDialogueForced: false,
        itemList: [],
        proxyRobotId: 0,
        isActive: true
    };

    defaultPrompt: string = '';
    private formData: IChatFormData = cloneDeep(this.defaultFormData);

    searchLoading: Boolean = false;
    orgDetailList: any = [];
    userList: CommonTypes.UserInfoItem[] = [];
    rgItemList: IGetRgAvailableItemListResponse['items'] = [];
    isSubmitting: boolean = false;

    private supportLLMList: string[] = [];
    private _rgId: number | undefined;

    async created() {
        this._rgId = this._parseRgId();
        await this._initSupportLLMList(this._rgId);
        this._initFormData();
        await this._initRgAvailableItems();
    }

    private _initializeFormData(config: IChatFormData) {
        this.formData = cloneDeep(config);
        this.formData.llmHumanServiceTransferConf = this.formData.llmHumanServiceTransferConf || this.defaultLLMHumanServiceTransferConf;
        this.formData.llmHumanServiceTransferConf.notShownTiming = this.formData.llmHumanServiceTransferConf.notShownTiming || {
            whenSpecialChars: false,
            whenFirstRoundDialogue: false
        };
        this.formData.itemList = this._toItemIdList(this.formData.itemList);
        this.formData.authorizedUserList = this._toAuthorizedUserList(this.formData.authorizedUserList);
    }

    @Watch('createType')
    handleCreateTypeChange(val) {
        const robotType = createTypeMapping[val];
        this.handleTypeChange(robotType);
    }

    private _initFormData() {
        if (this.robotConfigs.length > 0) {
            let config = this.robotConfigs.filter(item => item.isActive)[0];

            /**
             * 两个都是false 时，取第一个
             */
            if (!config && this.robotConfigs.length > 0) {
                config = this.robotConfigs[0];
            }
            /**
             * 从后端数据返回中渲染激活的机器人配置，后端没有存储走默认
             */
            if (config) {
                this._initializeFormData(config);
            }
        } else {
            this.formData = {
                type: 'SMART_NEW',
                ...this.defaultFormData,
                prompt: this.defaultPrompt,
                llmModel: this.supportLLMList[0] || ''
            };
        }

        console.log(this.formData, 'formData');
    }

    private _parseRgId(): number {
        return parseInt(this.$route.query.rgId as string, 10);
    }

    async _initSupportLLMList(rgId: number) {
        try {
            const { data, code } = await getSupportLLMList(rgId);
            if (code === 200) {
                this.supportLLMList = data.modelList;
                this.defaultPrompt = data.defaultPrompt;
            }
        } catch (_) {}
    }

    async remoteMethod(query) {
        if (!query) return;
        this.searchLoading = true;
        try {
            const res = await searchUser({ keyword: query, includeExternal: true });
            this.userList = res.data.items as any;
        } catch (e) {
            this.userList = [];
        }
        this.searchLoading = false;
    }

    handleIsDialogueForcedChange(b: boolean): void {
        const openDialogueConfirm = (): void => {
            this.$mtd
                .confirm({
                    title: '提示',
                    message: '此开关关闭后将强制用户进入智能问答页面，为避免产生客诉，请您提前做好运营宣导。',
                    width: '400px',
                    type: 'warning',
                    okButtonText: '知道了'
                })
                .catch(() => {});
        };

        const isClosing = !b;
        if (isClosing) openDialogueConfirm();
    }

    private async _initRgAvailableItems() {
        const type = this.formData.type === 'SMART_NEW' ? 'SYSTEM_SERVICE_NEW' : 'SYSTEM_SERVICE_LINK';
        try {
            const { data, code } = await getRgAvailableItemList({ rgId: this._rgId });
            if (code === 200) {
                this.rgItemList = data.items;
            }
        } catch (_) {}
    }

    private get rules() {
        return {
            robotName: [
                {
                    required: true,
                    trigger: ['blur', 'change'],
                    message: '机器人名称为空或超过 20 长度，请检查',
                    validator: (rule, value, callback) => {
                        if (this.formData.type === 'SMART_LINK') {
                            callback();
                        } else if (!value) {
                            callback(new Error('机器人名称不能为空'));
                        } else {
                            if (value.length > 20) {
                                callback(new Error('机器人名称不能超过20个字符'));
                            }
                            callback();
                        }
                    }
                }
            ],
            llmModel: [
                {
                    required: true,
                    message: '大模型不能为空',
                    trigger: 'blur',
                    validator: (rule, value, callback) => {
                        if (this.formData.type === 'SMART_LINK') {
                            callback();
                        } else if (!value) {
                            callback(new Error('大模型不能为空'));
                        } else {
                            callback();
                        }
                    }
                }
            ],
            prompt: [
                {
                    required: true,
                    message: 'prompt 不能为空',
                    trigger: 'blur',
                    validator: (rule, value, callback) => {
                        if (this.formData.type === 'SMART_LINK') {
                            callback();
                        } else if (!value) {
                            callback(new Error('prompt 不能为空'));
                        } else {
                            callback();
                        }
                    }
                }
            ],
            robotId: [
                {
                    required: true,
                    message: '大模型机器人ID 不能为空',
                    trigger: 'blur',
                    validator: (rule, value, callback) => {
                        if (this.formData.type === 'SMART_NEW') {
                            callback();
                        } else if (!this.formData.llmRobotId) {
                            callback(new Error('大模型机器人ID 不能为空'));
                        } else {
                            callback();
                        }
                    }
                }
            ],
            llmTenantId: [
                {
                    required: true,
                    message: '模型平台租户ID 不能为空',
                    trigger: 'blur',
                    validator: (rule, value, callback) => {
                        if (this.formData.type === 'SMART_NEW') {
                            callback();
                        } else if (!value) {
                            callback(new Error('模型平台租户ID 不能为空'));
                        } else {
                            callback();
                        }
                    }
                }
            ],

            authorizedOrgList: [
                {
                    message: '请至少选择一个授权组织或授权用户',
                    trigger: 'blur',
                    validator: (rule, value, callback) => {
                        const hasOrgs = this.formData.authorizedOrgList && this.formData.authorizedOrgList.length > 0;
                        const hasUsers = this.formData.authorizedUserList && this.formData.authorizedUserList.length > 0;
                        if (!hasOrgs && !hasUsers) {
                            callback(new Error('请至少选择一个授权组织或授权用户'));
                        } else {
                            callback();
                        }
                    }
                }
            ],
            itemList: [
                {
                    required: true,
                    message: '请至少选择一个服务目录',
                    trigger: 'blur',
                    validator: (rule, value, callback) => {
                        if (!this.formData.itemList || this.formData.itemList.length === 0) {
                            callback(new Error('请至少选择一个服务目录'));
                        }
                        callback();
                    }
                }
            ],
            RoutingAddrType: [
                {
                    validator: (rule, value, callback) => {
                        const { routingAddrType, routingAddr } = this.formData.llmHumanServiceTransferConf;
                        if (this.formData.type === 'SMART_LINK') {
                            return callback();
                        }
                        if (!routingAddr) {
                            return callback(new Error('转人工地址不能为空'));
                        }

                        callback();
                    },
                    trigger: ['blur', 'change']
                }
            ]
        };
    }

    /**
     * 后端返回是一个itemList，前端需要的是一个itemIdList.
     */
    private _toItemIdList(itemList: any): any[] {
        return itemList.map(v => v.itemId);
    }

    private _toAuthorizedUserList(authorizedUserList: any): string[] {
        return authorizedUserList.map(v => {
            return v.username;
        });
    }

    handleRoutingTypeChange(item) {
        this.formData.llmHumanServiceTransferConf.routingAddr = '';
    }

    handleTypeChange(val) {
        (this.$refs.form as any).clearValidate();

        const config = this.robotConfigs.filter(item => item.type === val);
        if (config.length > 0) {
            this._initializeFormData(config[0]);
            this.formData.type = val;
            console.log(this.formData, 'formData');
        } else {
            this.formData = cloneDeep(this.defaultFormData);
            this.formData.prompt = this.defaultPrompt;
            this.formData.llmModel = this.supportLLMList[0] || '';
            this.formData.type = val;
        }
    }

    formatter(val) {
        if (val.value) {
            return `${val.value.orgName}`;
        }
    }
    async searchOrg(query) {
        if (query.length < 1) {
            // this.orgDetailList = defaultOption;
            return;
        }
        this.searchLoading = true;
        try {
            const res = await orgDetailByPath(encodeURIComponent(query));
            const { data } = res;
            if (data) {
                this.orgDetailList = [data];
            } else {
                this.orgDetailList = [];
            }
        } catch (e) {
            console.log(e);
        }
        this.searchLoading = false;
    }

    onUserChanged(userList) {
        console.log('userList', userList);
        this.formData.authorizedUserList = userList;
    }

    onOrgChange(orgList) {
        this.formData.authorizedOrgList = orgList.map(org => {
            return {
                orgId: org.orgId,
                orgName: org.orgName
            };
        });
    }

    handleSubmit() {
        (this.$refs.form as any).validate(async (valid: boolean) => {
            if (!valid) {
                return;
            }

            this.isSubmitting = true; // 开始加载

            if (valid) {
                // 提交表单
                const payload: any = {
                    llmPlatform: 'FRIDAY',
                    type: this.formData.type,
                    robotName: this.formData.robotName,
                    llmModel: this.formData.llmModel,
                    prompt: this.formData.prompt,
                    llmTenantId: this.formData.llmTenantId,
                    llmRobotId: this.formData.llmRobotId,
                    authorizedUserMisList: this.formData.authorizedUserList,
                    authorizedOrgIdList: this.formData.authorizedOrgList.map(item => Number(item.orgId)),
                    llmHumanServiceTransferConf: {
                        type: 'FRIDAY',
                        ...this.formData.llmHumanServiceTransferConf
                    },
                    isDialogueForced: this.formData.isDialogueForced,
                    itemIdList: this.formData.itemList
                };

                /**
                 * 修改数据时
                 */
                if (this.formData.proxyRobotId > 0) {
                    payload.proxyRobotId = this.formData.proxyRobotId;
                }

                try {
                    const result = await saveRobotInfo(this._rgId, payload);
                    if (result.code !== 200) {
                        this.$mtd.message.error('保存失败, 原因:' + result.message);
                    } else {
                        this.$mtd.message.success('保存成功');
                        setTimeout(() => {
                            location.reload();
                        }, 1000);
                    }
                } catch (_) {
                } finally {
                    this.isSubmitting = false;
                }
            }
        });
    }
}
